import { getSystemName } from '@/api/systemApi.js'

export const BRANDING_STORAGE_KEY = 'systemBranding'
export const SYSTEM_NAME_STORAGE_KEY = 'systemName'
export const DEFAULT_SYSTEM_NAME = '量表智慧评估系统'
export const DEFAULT_BRANDING = {
  systemName: DEFAULT_SYSTEM_NAME,
  logoUrl: '/static/img/logo.png',
  faviconUrl: '',
  loginBackgroundUrl: '/static/img/background.jpg',
  loginPageVariant: 'modern'//modern  legacy
}

function normalizeBranding(branding) {
  const mergedBranding = {
    ...DEFAULT_BRANDING,
    ...(branding || {})
  }
  mergedBranding.systemName = mergedBranding.systemName || DEFAULT_SYSTEM_NAME
  mergedBranding.logoUrl = mergedBranding.logoUrl || DEFAULT_BRANDING.logoUrl
  mergedBranding.faviconUrl = mergedBranding.faviconUrl || mergedBranding.logoUrl
  mergedBranding.loginBackgroundUrl = mergedBranding.loginBackgroundUrl || DEFAULT_BRANDING.loginBackgroundUrl
  mergedBranding.loginPageVariant = mergedBranding.loginPageVariant || DEFAULT_BRANDING.loginPageVariant
  return mergedBranding
}

function ensureFavicon(faviconUrl) {
  if (typeof document === 'undefined' || !faviconUrl) return
  let faviconLink = document.getElementById('app-favicon')
  if (!faviconLink) {
    faviconLink = document.querySelector("link[rel='icon']") || document.createElement('link')
    faviconLink.id = 'app-favicon'
    faviconLink.rel = 'icon'
    if (!faviconLink.parentNode) {
      document.head.appendChild(faviconLink)
    }
  }
  faviconLink.href = faviconUrl
}

export function getCachedBranding() {
  if (typeof window !== 'undefined' && window.__APP_BRANDING__) {
    return normalizeBranding(window.__APP_BRANDING__)
  }
  let cachedBranding = {}
  try {
    cachedBranding = JSON.parse(sessionStorage.getItem(BRANDING_STORAGE_KEY) || '{}')
  } catch (e) {
    cachedBranding = {}
  }
  const legacySystemName = sessionStorage.getItem(SYSTEM_NAME_STORAGE_KEY)
  if (legacySystemName && !cachedBranding.systemName) {
    cachedBranding.systemName = legacySystemName
  }
  return normalizeBranding(cachedBranding)
}

export function getCachedSystemName() {
  return getCachedBranding().systemName
}

export function getCachedLogoUrl() {
  return getCachedBranding().logoUrl
}

export function getCachedFaviconUrl() {
  return getCachedBranding().faviconUrl
}

export function getCachedLoginBackgroundUrl() {
  return getCachedBranding().loginBackgroundUrl
}

export function getCachedLoginPageVariant() {
  return getCachedBranding().loginPageVariant
}

export function applyBranding(branding) {
  const finalBranding = normalizeBranding(branding)
  if (typeof window !== 'undefined') {
    window.__APP_BRANDING__ = finalBranding
    window.__SYSTEM_NAME__ = finalBranding.systemName
  }
  sessionStorage.setItem(BRANDING_STORAGE_KEY, JSON.stringify(finalBranding))
  sessionStorage.setItem(SYSTEM_NAME_STORAGE_KEY, finalBranding.systemName)
  if (typeof document !== 'undefined') {
    document.title = finalBranding.systemName
    ensureFavicon(finalBranding.faviconUrl)
  }
  return finalBranding
}

export function applySystemName(systemName) {
  return applyBranding({
    ...getCachedBranding(),
    systemName
  }).systemName
}

export async function bootstrapBranding() {
  if (typeof window !== 'undefined' && window.__APP_BRANDING__) {
    return applyBranding(window.__APP_BRANDING__)
  }
  try {
    const { data } = await getSystemName()
    const systemName = data && data.data ? data.data.systemName : ''
    return applyBranding({
      ...getCachedBranding(),
      systemName
    })
  } catch (e) {
    return applyBranding(getCachedBranding())
  }
}

export async function bootstrapSystemName() {
  const branding = await bootstrapBranding()
  return branding.systemName
}



// WEBPACK FOOTER //
// ./src/utils/system_branding.js